import React, { Component } from 'react'
import { Row, Col, Form, Upload, Input, Select, Cascader, Button, Icon, Spin, Tag, Modal, DatePicker } from 'antd'
import moment from "moment"
import underscore from "underscore"
import { app } from "../../app"
import config from "../../config"
import api from "../../api"
import moment_locale from 'antd/lib/date-picker/locale/zh_CN'
import BraftEditor from 'braft-editor'
import { ContentUtils } from 'braft-utils'
import { ImageUtils } from 'braft-finder'
import 'braft-editor/dist/index.css'

const FormItem = Form.Item
const Option = Select.Option
const RangePicker = DatePicker.RangePicker

const normFile = (e) => {
    console.log('Upload event:', e)
    if (Array.isArray(e)) {
        return e
    }
    return e && e.fileList
}

const formItemLayout = (span = 16) => {
    return {
        labelCol: { span: 4 },
        wrapperCol: { span },
    }
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg】！', 'error')
        return Promise.reject(false)
    }
    return Promise.resolve(true)
}

/**
 * 上传之前2
 * @param file
 */
function beforeUpload2 (file) {
    const isLt2M = file.size / 1024 / 1024 < 2, types = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
    if (!isLt2M) {
        app.alert('图片最大2MB！', 'error')
        return Promise.reject(false)
    } else if (types.indexOf(file.type) === -1) {
        app.alert('仅支持上传【.png, .jpg, .gif】！', 'error')
        return Promise.reject(false)
    }

    return Promise.resolve(true)
}

function handlePPE (ppes) {
    for (let i = 0; i < ppes.length; i++) {
        ppes[i].label = ppes[i].names
        ppes[i].value = JSON.stringify({ name: ppes[i].names, id: ppes[i].id })
        if (ppes[i].subclass && ppes[i].subclass.length > 0) {
            ppes[i].children = handlePPE(ppes[i].subclass)
        }
    }
    return ppes
}

class EMEdit extends Component {
    constructor (props) {
        super(props)
        let selPpeList = [], searchplayerList = [], head_img = null
        if (props.info) {
            console.log(props.info)
            // selPpeList = props.info.ppe_class || []
            searchplayerList.push({
                indexno: props.info.indexno,
                vname: props.info.name,
                localpath: props.info.head_img,
                sex: props.info.sex,
                mobile: props.info.mobile,
                bsrno: props.info.bsrno
            })
            head_img = props.info.head_img
        }
        this.state = {
            search_loading: false,
            photo_loading: false,
            submit_loading: false,
            searchplayerList,
            selPpeList,
            head_img,
        }
    }

    componentDidMount () {
        this._isMounted = true
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 搜索人员数据
     * @returns {Promise<void>}
     */
    handleSearchPlayer = async (search_val) => {
        if (!search_val) {
            await this.setData({ searchplayerList: [] })
            return
        }
        await this.setData({ search_loading: true })
        let params = {
            search_val,
            search_type: 'searchform_name',
            is_expert: 'expert',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }, { flag, data, msg } = await app.post(api.HomeSearch, params)
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        await this.setData({ searchplayerList: data, search_loading: false })
    }

    /**
     * 提交
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault()
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                const { head_img, selPpeList } = this.state
                if (!head_img) {
                    app.alert('头像上传无效', 'warn')
                    return
                }
                // if (!selPpeList.length) {
                //     app.alert('请添加专职课程', 'warn')
                //     return
                // }
                await this.setData({ submit_loading: true })
                values.head_img = head_img
                // values.ppe_class_id = selPpeList.map(p => p.id).join(',')
                values.ppe_class_id = values.ppe_class_id.join(',')
                values.employ_start = values.date[0].format('YYYY-MM-DD')
                values.employ_end = values.date[1].format('YYYY-MM-DD')
                const certificate_img = []
                for (let i = 0; i < values.certificate_img.length; i++) {
                    if (values.certificate_img[i].response && values.certificate_img[i].response.flag === 1) {
                        certificate_img.push(values.certificate_img[i].response.data.url)
                    }
                }
                values.certificate_img = certificate_img.join(':::')
                values.descript = values.descript.toHTML()
                values.record = values.record.toHTML()
                delete values.date
                console.log(values)
                const { info } = this.props
                let flag = await this.props.success(values, info ? info.id : undefined)
                if (flag) {
                    await this.setData({ submit_loading: false, searchplayerList: [], selPpeList: [], head_img: null })
                    this.props.form.resetFields()
                }

            }
        })
    }

    /**
     * 打开添加技能
     */
    handleOpenAddPpe = () => {
        let ppe_class_id = null
        Modal.confirm({
            centered: true,
            title: '添加专职课程',
            content: (
                <Cascader options={handlePPE(this.props.ppes)}
                          placeholder="请选择"
                          allowClear={false}
                          displayRender={label => label[label.length - 1]}
                          style={{ width: '16rem', fontSize: '.8rem' }}
                          onChange={(value) => {
                              ppe_class_id = value[value.length - 1]
                          }}
                />
            ),
            icon: <Icon type="plus-circle" style={{ color: '#1890ff' }}/>,
            onOk: () => {
                if (!ppe_class_id) {
                    app.alert('请选择专职课程', 'warn')
                    return Promise.reject()
                }
                const ppe_class = JSON.parse(ppe_class_id)
                const { selPpeList } = this.state
                if (selPpeList.findIndex(p => p.id === ppe_class.id) !== -1) {
                    app.alert('此专职课程已添加', 'warn')
                    return Promise.reject()
                }
                selPpeList.push(ppe_class)
                this.setData({ selPpeList: [...selPpeList] })
            }
        })
    }

    /**
     * 删除技能
     * @param id
     */
    handleDelPpe = (id) => {
        const selPpeList = this.state.selPpeList.filter(p => id !== p.id)
        this.setData({ selPpeList })
    }

    /**
     * 头像上传变更
     * @param info
     */
    handlePhotoChange = (info) => {
        if (info.file.status === 'uploading') {
            this.setData({ head_img: null, photo_loading: true })
            return
        }
        if (info.file.status === 'done') {
            const state = { photo_loading: false }
            if (info.file.response && info.file.response.flag === 1) {
                state.head_img = info.file.response.data.url
            }
            this.setData(state)
        }
    }

    /**+
     * 是否内部变更
     * @param value
     */
    handleVolunteerChange = () => {
        this.props.form.resetFields()
        this.props.form.setFieldsValue({
            positional_id: undefined
        })
        this.setData({ photo_loading: false, searchplayerList: [], search_loading: false, selPpeList: [] })
    }


    /**
     * 选择队员变更
     * @param value
     */
    handleSelectPlayerChange = (value) => {
        const { searchplayerList } = this.state
        const player = underscore.find(searchplayerList, (p) => p.indexno === value)
        if (player) {
            this.props.form.setFieldsValue({
                name: player.vname,
                sex: player.sex,
                mobile: player.mobile,
                expert_indexno: player.indexno,
                head_img: [{
                    uid: new Date().getTime(),
                    status: 'done',
                    response: {
                        flag: 1,
                        data: {
                            url: player.localpath
                        }
                    },
                    name: "头像",
                    thumbUrl: config.imgUrl + player.localpath
                }]
            })
            this.setData({ head_img: player.localpath })
        } else {
            app.alert('获取失败', 'error')
        }
    }

    /**
     * 预览
     */
    handlePreview = (name) => {
        const html = this.props.form.getFieldValue(name).toHTML()
        if (!html || html === '<p></p>') {
            app.alert('您填写内容后才可预览！', 'warn')
            return
        }
        if (window.previewWindow) {
            window.previewWindow.close()
        }
        window.previewWindow = window.open()
        window.previewWindow.document.write(html)
        window.previewWindow.document.close()

    }

    /**
     * 编辑器图片上传
     * @param file
     * @returns {boolean}
     */
    editorUploadHandler = ({ file }, name) => {
        if (!file) {
            return false
        }
        if (file.status === 'done' && file.response && file.response.flag === 1) {
            let obj = {}
            obj[name] = ContentUtils.insertMedias(this.props.form.getFieldValue(name), [{
                type: 'IMAGE',
                url: config.imgUrl + file.response.data.url
            }])
            this.props.form.setFieldsValue(obj)
        } else if (file.status === 'error') {
            app.alert('上传失败', 'error')
        }
    }

    /**
     * 预览HTML
     **/
    buildPreviewHtml = (html) => {
        return `
              <!Doctype html>
              <html>
                <head>
                  <title>预览内容</title>
                  <style>
                    html,body{
                      height: 100%;
                      margin: 0;
                      padding: 0;
                      overflow: auto;
                      background-color: #f1f2f3;
                    }
                    .container{
                      box-sizing: border-box;
                      width: 1000px;
                      max-width: 100%;
                      min-height: 100%;
                      margin: 0 auto;
                      padding: 30px 20px;
                      overflow: hidden;
                      background-color: #fff;
                      border-right: solid 1px #eee;
                      border-left: solid 1px #eee;
                    }
                    .container img,
                    .container audio,
                    .container video{
                      max-width: 100%;
                      height: auto;
                    }
                    .container p{
                      white-space: pre-wrap;
                      min-height: 1em;
                    }
                    .container pre{
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-radius: 5px;
                    }
                    .container blockquote{
                      margin: 0;
                      padding: 15px;
                      background-color: #f1f1f1;
                      border-left: 3px solid #d1d1d1;
                    }
                  </style>
                </head>
                <body>
                  <div class="container">${html}</div>
                </body>
              </html>
            `
    }

    render () {
        let { positionals, info, cancel, ppes } = this.props,
            { getFieldDecorator, getFieldValue } = this.props.form,
            is_volunteer = getFieldValue('is_volunteer'),
            { search_loading, searchplayerList, selPpeList, photo_loading, head_img } = this.state
        if (info && !is_volunteer) {
            is_volunteer = info.is_volunteer
        }
        const excludeControls = ['media', 'emoji', 'code'], extendControls = [
            {
                key: 'custom-button',
                type: 'button',
                text: '预览',
                onClick: () => this.handlePreview('descript')
            },
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'expert_certificate'
                        }}
                        name="image"
                        onChange={(file) => this.editorUploadHandler(file, 'descript')}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled"/>
                        </button>
                    </Upload>
                )
            }
        ], extendControls2 = [
            {
                key: 'custom-button',
                type: 'button',
                text: '预览',
                onClick: () => this.handlePreview('record')
            },
            {
                key: 'antd-uploader',
                type: 'component',
                component: (
                    <Upload
                        accept="image/png,image/jpeg,image/gif"
                        showUploadList={false}
                        action={config.serverUrl + api.ImageUpload}
                        beforeUpload={beforeUpload2}
                        data={{
                            token: app.getData('token'),
                            indexno: app.getData('indexno'),
                            account: app.getData('account'),
                            upload_type: 'expert_certificate'
                        }}
                        name="image"
                        onChange={(file) => this.editorUploadHandler(file, 'record')}
                    >
                        {/* 这里的按钮最好加上type="button"，以避免在表单容器中触发表单提交，用Antd的Button组件则无需如此 */}
                        <button type="button" className="control-item button upload-button" data-title="插入图片">
                            <Icon type="picture" theme="filled"/>
                        </button>
                    </Upload>
                )
            }
        ]
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <FormItem
                        label="是否内部"
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('is_volunteer', {
                            rules: [{ required: true, message: '请选择!' }],
                            initialValue: info ? info.is_volunteer + '' : undefined
                        })(
                            <Select placeholder="请选择" onChange={this.handleVolunteerChange}>
                                <Option value="1">是</Option>
                                <Option value="0">否</Option>
                            </Select>
                        )}
                    </FormItem>
                    {
                        is_volunteer === '1' ? (
                            <FormItem
                                label="内部人员"
                                {...formItemLayout(8)}
                            >
                                {getFieldDecorator('expert_indexno', {
                                    rules: [{ required: true, message: '请选择!' }],
                                    initialValue: info ? info.indexno : undefined
                                })(
                                    <Select placeholder="请输入名称搜索" onSearch={this.handleSearchPlayer}
                                            notFoundContent={search_loading ? <Spin size="small"/> : "无搜索内容"}
                                            defaultActiveFirstOption={false}
                                            showArrow={false}
                                            filterOption={false}
                                            allowClear
                                            onChange={this.handleSelectPlayerChange}
                                            showSearch>
                                        {
                                            searchplayerList.map(p => {
                                                return (
                                                    <Option key={p.indexno}
                                                            value={p.indexno}>{`${p.vname}（${p.bsrno || '-'}）`}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )}
                            </FormItem>
                        ) : null
                    }
                    <FormItem
                        label="头像"
                        {...formItemLayout()}
                    >
                        {getFieldDecorator('head_img', {
                            valuePropName: 'fileList',
                            getValueFromEvent: normFile,
                            rules: [{ required: true, message: '请上传头像!' }],
                            initialValue: info ? [{
                                uid: new Date().getTime(),
                                status: 'done',
                                response: {
                                    flag: 1,
                                    data: {
                                        url: info.head_img
                                    }
                                },
                                name: "头像",
                                thumbUrl: config.imgUrl + info.head_img
                            }] : []
                        })(
                            <Upload
                                name="image"
                                accept="image/png,image/jpeg"
                                showUploadList={false}
                                action={config.serverUrl + api.ImageUpload}
                                beforeUpload={beforeUpload}
                                listType="picture-card"
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'expert'
                                }}
                                disabled={is_volunteer === '1'}
                                onChange={this.handlePhotoChange}
                            >
                                {head_img ? (
                                        <div style={{ width: 140, height: 104 }}>
                                            <img style={{
                                                maxWidth: '100%',
                                                width: 'auto',
                                                height: 'auto',
                                                maxHeight: '100%'
                                            }} src={config.imgUrl + head_img} alt="头像"/>
                                        </div>
                                    ) :
                                    (
                                        <div>
                                            <Icon type={photo_loading ? 'loading' : 'plus'}/>
                                            <div className="ant-upload-text">上传</div>
                                        </div>
                                    )
                                }
                            </Upload>
                        )}
                    </FormItem>
                    <FormItem
                        label="姓名"
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('name', {
                            rules: [
                                { required: true, message: '请输入姓名' }
                            ],
                            initialValue: info ? info.name : ''
                        })(
                            <Input placeholder="请输入姓名" disabled={is_volunteer === '1'}/>
                        )}
                    </FormItem>
                    <FormItem
                        label="性别"
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('sex', {
                            rules: [
                                { required: true, message: '请选择性别' }
                            ],
                            initialValue: info ? info.sex : ''
                        })(
                            <Select placeholder="请选择性别" disabled={is_volunteer === '1'}>
                                <Option value="男">男</Option>
                                <Option value="女">女</Option>
                            </Select>
                        )}
                    </FormItem>
                    <FormItem
                        label="手机号"
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('mobile', {
                            rules: [
                                { required: true, message: '请输入手机号' }
                            ],
                            initialValue: info ? info.mobile : ''
                        })(
                            <Input placeholder="请输入手机号" disabled={is_volunteer === '1'}/>
                        )}
                    </FormItem>
                    <FormItem
                        label="职称类别"
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('positional_id', {
                            rules: [
                                { required: true, message: '请选择职称类别' }
                            ],
                            initialValue: info ? info.positional_id : undefined
                        })(
                            <Select placeholder="请选择职称类别">
                                {
                                    positionals.map(p => {
                                        let disabled = false
                                        if (is_volunteer === '1') {
                                            if (p.is_volunteer !== 1) {
                                                disabled = true
                                            }
                                        } else if (p.is_volunteer === 1){
                                            disabled = true
                                        }
                                        return (
                                            <Option key={p.value} value={p.value} disabled={disabled}>{p.title}</Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </FormItem>
                    {/*<FormItem*/}
                        {/*label="专职课程"*/}
                        {/*required={true}*/}
                        {/*{...formItemLayout(8)}*/}
                    {/*>*/}
                        {/*<div>*/}
                            {/*{*/}
                                {/*selPpeList.map((p, i) => {*/}
                                    {/*return (*/}
                                        {/*<Tag key={i} closable onClose={(e) => {*/}
                                            {/*e.preventDefault()*/}
                                            {/*this.handleDelPpe(p.id)*/}
                                        {/*}}>{p.name}</Tag>*/}
                                    {/*)*/}
                                {/*})*/}
                            {/*}*/}
                            {/*<Button size="small" type="primary" icon="plus"*/}
                                    {/*onClick={() => this.handleOpenAddPpe()}>添加</Button>*/}
                        {/*</div>*/}
                    {/*</FormItem>*/}
                    <FormItem
                        label="专职课程"
                        required={true}
                        {...formItemLayout(8)}
                    >
                        {getFieldDecorator('ppe_class_id', {
                            rules: [
                                { required: true, message: '请选择专职课程' }
                            ],
                            initialValue: info ? info.ppe_class_id : undefined
                        })(
                            <Select placeholder="请选择专职课程" mode="multiple">
                                {
                                    ppes.map(p => {
                                        return (
                                            <Option key={p.id} value={p.id}>{p.names}</Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem
                        label="聘用期限"
                        {...formItemLayout()}
                    >
                        {getFieldDecorator('date', {
                            rules: [{ type: 'array', required: true, message: '请选择聘用期限' }],
                            initialValue: info ? [moment(info.employ_start), moment(info.employ_end)] : []
                        })(
                            <RangePicker locale={moment_locale}/>
                        )}
                    </FormItem>
                    <FormItem
                        label="证书"
                        {...formItemLayout(20)}
                    >
                        {getFieldDecorator('certificate_img', {
                            rules: [
                                { required: true, message: "证书图片必传！" },
                            ],
                            valuePropName: 'fileList',
                            getValueFromEvent: (e) => {
                                if (Array.isArray(e)) {
                                    return e
                                }
                                return e && e.fileList
                            },
                            initialValue: info ? (info.certificate_img || []).map((img, i) => {
                                i += 1
                                return {
                                    uid: i - i * 2,
                                    status: 'done',
                                    response: {
                                        flag: 1,
                                        data: {
                                            url: img
                                        }
                                    },
                                    name: "图片" + i,
                                    thumbUrl: config.imgUrl + img
                                }
                            }) : []
                        })(
                            <Upload
                                accept='image/jpeg, image/jpg, image/png'
                                action={config.serverUrl + api.ImageUpload}
                                beforeUpload={beforeUpload}
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'expert_certificate'
                                }}
                                name="image"
                                listType="picture"
                                showUploadList={true}
                                className="upload-list-inline"
                            >
                                <Button type="primary">
                                    <Icon type="upload"/> 点击上传
                                </Button>
                            </Upload>
                        )}
                    </FormItem>
                    <FormItem
                        label="个人简介"
                        {...formItemLayout()}
                    >
                        {getFieldDecorator('descript', {
                            validateTrigger: 'onBlur',
                            initialValue: BraftEditor.createEditorState(info ? info.descript : null),
                            rules: [{
                                required: true,
                                validator: (_, value, callback) => {
                                    if (value.isEmpty()) {
                                        callback('请填写个人简介')
                                    } else {
                                        callback()
                                    }
                                }
                            }],
                        })(
                            <BraftEditor
                                style={{ border: '1px solid #eee' }}
                                excludeControls={excludeControls}
                                extendControls={extendControls}
                                stripPastedStyles={true}
                                placeholder="请填写个人简介"
                            />
                        )}
                    </FormItem>
                    <FormItem
                        label="个人履历"
                        {...formItemLayout()}
                    >
                        {getFieldDecorator('record', {
                            validateTrigger: 'onBlur',
                            initialValue: BraftEditor.createEditorState(info ? info.record : null),
                            rules: [{
                                required: true,
                                validator: (_, value, callback) => {
                                    if (value.isEmpty()) {
                                        callback('请输入个人履历')
                                    } else {
                                        callback()
                                    }
                                }
                            }]
                        })(
                            <BraftEditor
                                style={{ border: '1px solid #eee' }}
                                excludeControls={excludeControls}
                                extendControls={extendControls2}
                                stripPastedStyles={true}
                                placeholder="请填写个人履历"
                            />
                        )}
                    </FormItem>
                    <Row>
                        <Col offset={4}>
                            <Button type="primary" htmlType="submit">提交</Button>
                            <Button style={{ marginLeft: '2rem' }} onClick={cancel}>取消</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }
}

export default Form.create()(EMEdit)



// WEBPACK FOOTER //
// ./src/routes/expert/EMEdit.jsx